import { Component, OnInit } from '@angular/core';
import { ProfileTypeIdentifier } from '@enum/profile-type-identifier';
import { Entity } from '@model/entities/entity';
import { EntityTypeConfig } from '@model/entity-type-config';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { ScrollService } from '@service/scroll.service';
import { StateService } from '@service/state.service';
import { UrlPrettifierService } from '@service/urlPrettifier/url-prettifier.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';

@Component({
  template: ''
})
export abstract class EntityCardComponent implements OnInit {

  public ProfileTypeIdentifier = ProfileTypeIdentifier

  protected abstract entityTypeIdentifier: EntityTypeIdentifier

  protected abstract entity: Entity

  public entityTypeConfig: EntityTypeConfig = null

  constructor(
    protected entityTypeConfigService: EntityTypeConfigService,
    protected ScrollService: ScrollService,
    public StateService: StateService
  ) { }

  public ngOnInit() {
    this.entityTypeConfig = this.entityTypeConfigService.getConfigByName(this.entityTypeIdentifier)
  }

  public goToItemDetails() {

    // remember scroll before transition
    let scroll = this.ScrollService.getCurrentScroll()

    this.StateService.goto(
      this.entityTypeConfig.detailstate + "/" + this.entity.id + "/" + UrlPrettifierService.prettyUrl(this.entity.title)
    )
      .then(() => {

        // go back to scroll position in list if returning to list
        this.ScrollService.registerScrollToPositionBeforeHook(
          this.entityTypeConfig.liststate,
          scroll
        )

      })
  }

  public stopPropagation($event: Event) {
    $event.stopPropagation()
  }

}